// removed by extract-text-webpack-plugin
module.exports = {"cmodal-title":"cmodal-title","dna-icon":"dna-icon","ant-modal-header":"ant-modal-header","ant-modal-close":"ant-modal-close","ant-modal-footer":"ant-modal-footer","ant-btn":"ant-btn"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/CModal/Index.scss
// module id = 1380
// module chunks = 0